<template>
  <div class="content">
    <p class="title">围绕采购、生产、质量、设备等关键环节，为企业提供智改数转服务，助力企业提质降本增效</p>
    <div class="block_div">
      <div
        class="flex cardWrap"
        v-for="(item,index) in list"
        :key="index"
        @mouseover="curIndex = index"
        @mouseout="curIndex = 0"
        :class="curIndex == index ?'extendCard':''"
      >
        <div
          class="content-wrap"
          :style="{
         backgroundImage: `url(${curIndex === index?item.bgUrlExtend:item.bgUrl})`
         }"
        >
          <div class="item-title">{{item.title}}</div>
          <div class="item-text">{{item.text}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          title: "设备",
          bgUrl: require("@/assets/new/bg1.png"),
          bgUrlExtend: require("@/assets/new/extend1.png"),
          text:
            "实现账料相符，供销匹配，降低库存堆积，提升盘点效率及资金利用效率；"
        },
        {
          title: "质量",
          bgUrl: require("@/assets/new/bg2.png"),
          bgUrlExtend: require("@/assets/new/extend2.png"),
          text:
            "生产过程数据实时查看，准确、快速统计绩效、产出和成本，减少人工统计时间；"
        },
        {
          title: "生产",
          bgUrl: require("@/assets/new/bg3.png"),
          bgUrlExtend: require("@/assets/new/extend3.png"),
          text:
            "生产数据统一、规范、标准的管理，减少信息处理错漏和缺失问题，形成结果和统计报表，方便效率；"
        },
        {
          title: "采购",
          bgUrl: require("@/assets/new/bg4.png"),
          bgUrlExtend: require("@/assets/new/extend4.png"),
          text:
            "通过RFID自动识别技术智能获取产品信息，实现对物品高效、准确、自动化追踪和管理。"
        }
      ],
      curIndex: 0
    };
  },
  created() {},
  methods: {}
};
</script>
<style lang="less" scoped>
.content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 40px;

  .title {
    width: 1200px;
    height: 40px;
    font-size: 24px;
    font-family: ABCMarfa-Bold, ABCMarfa;
    font-weight: 400;
    color: #000000;
    line-height: 40px;
    margin-bottom: 15px;
  }

  .sub-title {
    width: 864px;
    height: 44px;
    margin-top: 16px;
    font-size: 16px;
    font-family: ABCMarfa-Bold, ABCMarfa;
    font-weight: 400;
    color: #000000;
    line-height: 22px;
  }

  .block_div {
    width: 1200px;
    margin-top: 40px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
  .extendCard {
    width: 400px !important;
  }
  .shrinkCard {
    width: 260px;
  }
  .cardWrap {
    flex-direction: column;
    justify-content: center;
    // align-items: center;
    width: 260px;
    height: 400px;
    background: no-repeat center center / 100% 100%;
    text-align: left;
    color: #fff;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.4s;
    &:hover {
      width: 400px;
    }
    .content-wrap {
      height: 100%;
      padding: 0px 15px;
      box-sizing: border-box;
      background: no-repeat center center / 100% 100%;
      .item-title {
        font-size: 20px;
        text-align: left;
        margin: 170px 0 10px 0;
      }
      .item-text {
        width: 240px;
        font-size: 14px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/homeIndex/digitizationProd.vue